export default __webpack_public_path__ + "static/media/findy_gradient.fc5b98ec.svg";